import styles from "./searchFast.module.css"
// import { useEffect, useState, useCallback } from "react"
import { useMediaQuery } from "react-responsive"
import { useDispatch, useSelector } from "react-redux"
// import { useActiveButtonCountryTagChoice } from "../../services/context/CountryFilterContext"
// import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import checkBoxEmpty from "../../images/check-box-empty.svg"
import arrowImgPopular from "../../images/sort-arrow-popular.svg"
import arrowDownGreen from "../../images/arrow-down-sign-to-navigate-green.svg"
import checkBoxFull from "../../images/check-box-full.svg"
import {
  setSelectAnalysisPoint,
  setSelectSubscriptionPoint,
  setSelectBondsPoint, setSelectChangeInPortfolios,
} from "../../services/reducers/search-vision-points-slice"
import {
  setAnalysisPoints,
  setSubscriptionPoints,
  setBondsPoints, setChangePortfoliosPoints,
} from "../../services/reducers/cards-filtred-slice"
import {
  selectAnalysisVision,
  selectSubscriptionVision,
  selectBondsVision, selectPortfoliosVision,
} from "../../services/selectors"
import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import { useCallback } from "react"

const SearchSectionFast = ({ selectRelevant, setActivRelevantWind }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 800px)" })
  const dispatch = useDispatch()
  const selectAnalysisPoint = useSelector(selectAnalysisVision)
  const selectSubscription = useSelector(selectSubscriptionVision)
  const selectBonds = useSelector(selectBondsVision)
  const selectPortfolios = useSelector(selectPortfoliosVision)
  const filters = useActiveFilters()

  return (
    <>
      {!isMobile && (
        <section className={styles.section}>
          <div className={styles.container}>
            <div className={styles.sectionPointsWrapper}>
              <div className={styles.sectionPoint}>
                {!selectSubscription ? (
                    <img
                        alt="img"
                        src={checkBoxEmpty}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectSubscriptionPoint(true))
                          dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                          filters.setPageCount(1)
                        }}
                    />
                ) : (
                    <img
                        alt="img"
                        src={checkBoxFull}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectSubscriptionPoint(false))
                          dispatch(setSubscriptionPoints(""))
                          filters.setPageCount(1)
                        }}
                    />
                )}
                С подпиской Unity
              </div>
              {/*
       <div className={styles.sectionPoint}>
       <img src={checkBoxEmpty} className={styles.checkBoxEmpty}/>

       C подпиской Ideas
       </div>
        */}
              <div className={styles.sectionPoint}>
                {!selectAnalysisPoint ? (
                    <img
                        alt="img"
                        src={checkBoxEmpty}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectAnalysisPoint(true))
                          dispatch(setAnalysisPoints("&analysis=true"))
                          filters.setPageCount(1)
                        }}
                    />
                ) : (
                    <img
                        alt="img"
                        src={checkBoxFull}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectAnalysisPoint(false))
                          dispatch(setAnalysisPoints(""))
                          filters.setPageCount(1)
                        }}
                    />
                )}
                Разборы компаний
              </div>

              <div className={styles.sectionPoint}>
                {!selectBonds ? (
                    <img
                        alt="img"
                        src={checkBoxEmpty}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectBondsPoint(true))
                          dispatch(setBondsPoints("&bonds=true"))
                          filters.setPageCount(1)
                        }}
                    />
                ) : (
                    <img
                        alt="img"
                        src={checkBoxFull}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectBondsPoint(false))
                          dispatch(setBondsPoints(""))
                          filters.setPageCount(1)
                        }}
                    />
                )}
                Облигации
              </div>

              <div className={styles.sectionPoint}>
                {!selectPortfolios ? (
                    <img
                        alt="img"
                        src={checkBoxEmpty}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectChangeInPortfolios(true))
                          dispatch(setChangePortfoliosPoints("&change_in_portfolios=true"))
                          filters.setPageCount(1)
                        }}
                    />
                ) : (
                    <img
                        alt="img"
                        src={checkBoxFull}
                        className={styles.checkBoxEmpty}
                        onClick={() => {
                          dispatch(setSelectChangeInPortfolios(false))
                          dispatch(setChangePortfoliosPoints(""))
                          filters.setPageCount(1)
                        }}
                    />
                )}
                Изменение в портфелях
              </div>
            </div>

            <div className={styles.relevantSectionWrapper}>
              <div
                  className={styles.relevantSection}
                  onClick={() => {
                    setActivRelevantWind((prev) => !prev)
                  }}
              >
                <svg className={styles.arrowImgPopular} width="25" height="24" viewBox="0 0 25 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <mask id="path-1-inside-1_1223_19034" fill="white">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M11.4395 9.5605L12.5 8.5L8 4L3.5 8.5L4.5605 9.5605L7.25 6.871L7.25 20H8.75L8.75 6.871L11.4395 9.5605ZM14.0605 14.4395L13 15.5L17.5 20L22 15.5L20.9395 14.4395L18.25 17.129V4H16.75V17.129L14.0605 14.4395Z"/>
                  </mask>
                  <path
                      d="M12.5 8.5L13.2071 9.20711L13.9142 8.5L13.2071 7.79289L12.5 8.5ZM11.4395 9.5605L10.7324 10.2676L11.4395 10.9747L12.1466 10.2676L11.4395 9.5605ZM8 4L8.70711 3.29289L8 2.58579L7.29289 3.29289L8 4ZM3.5 8.5L2.79289 7.79289L2.08579 8.5L2.79289 9.20711L3.5 8.5ZM4.5605 9.5605L3.85339 10.2676L4.5605 10.9747L5.26761 10.2676L4.5605 9.5605ZM7.25 6.871H8.25L8.25 4.45679L6.54289 6.16389L7.25 6.871ZM7.25 20H6.25V21H7.25V20ZM8.75 20V21H9.75V20H8.75ZM8.75 6.871L9.45711 6.16389L7.75 4.45679V6.871H8.75ZM13 15.5L12.2929 14.7929L11.5858 15.5L12.2929 16.2071L13 15.5ZM14.0605 14.4395L14.7676 13.7324L14.0605 13.0253L13.3534 13.7324L14.0605 14.4395ZM17.5 20L16.7929 20.7071L17.5 21.4142L18.2071 20.7071L17.5 20ZM22 15.5L22.7071 16.2071L23.4142 15.5L22.7071 14.7929L22 15.5ZM20.9395 14.4395L21.6466 13.7324L20.9395 13.0253L20.2324 13.7324L20.9395 14.4395ZM18.25 17.129H17.25V19.5432L18.9571 17.8361L18.25 17.129ZM18.25 4H19.25V3H18.25V4ZM16.75 4V3H15.75V4H16.75ZM16.75 17.129L16.0429 17.8361L17.75 19.5432V17.129H16.75ZM11.7929 7.79289L10.7324 8.85339L12.1466 10.2676L13.2071 9.20711L11.7929 7.79289ZM7.29289 4.70711L11.7929 9.20711L13.2071 7.79289L8.70711 3.29289L7.29289 4.70711ZM4.20711 9.20711L8.70711 4.70711L7.29289 3.29289L2.79289 7.79289L4.20711 9.20711ZM5.26761 8.85339L4.20711 7.79289L2.79289 9.20711L3.85339 10.2676L5.26761 8.85339ZM6.54289 6.16389L3.85339 8.85339L5.26761 10.2676L7.95711 7.57811L6.54289 6.16389ZM8.25 20L8.25 6.871H6.25L6.25 20H8.25ZM8.75 19H7.25V21H8.75V19ZM7.75 6.871L7.75 20H9.75L9.75 6.871H7.75ZM12.1466 8.85339L9.45711 6.16389L8.04289 7.57811L10.7324 10.2676L12.1466 8.85339ZM13.7071 16.2071L14.7676 15.1466L13.3534 13.7324L12.2929 14.7929L13.7071 16.2071ZM18.2071 19.2929L13.7071 14.7929L12.2929 16.2071L16.7929 20.7071L18.2071 19.2929ZM21.2929 14.7929L16.7929 19.2929L18.2071 20.7071L22.7071 16.2071L21.2929 14.7929ZM20.2324 15.1466L21.2929 16.2071L22.7071 14.7929L21.6466 13.7324L20.2324 15.1466ZM18.9571 17.8361L21.6466 15.1466L20.2324 13.7324L17.5429 16.4219L18.9571 17.8361ZM17.25 4V17.129H19.25V4H17.25ZM16.75 5H18.25V3H16.75V5ZM17.75 17.129V4H15.75V17.129H17.75ZM13.3534 15.1466L16.0429 17.8361L17.4571 16.4219L14.7676 13.7324L13.3534 15.1466Z"
                      mask="url(#path-1-inside-1_1223_19034)"/>
                </svg>

                {/*<img*/}
                {/*    alt="img"*/}
                {/*    src={arrowImgPopular}*/}
                {/*    className={styles.arrowImgPopular}*/}
                {/*/>*/}
                <div className={styles.txtButtom}>{selectRelevant}</div>

                <svg className={styles.arrowDownGreen} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M12.2246 15.775L18.7246 9.27498L17.6746 8.22498L12.2246 13.675L6.77461 8.22498L5.72461 9.27498L12.2246 15.775Z"
                      fill="#06813E"/>
                </svg>
              </div>
            </div>
          </div>
        </section>
      )}

      {isMobile && (
          <section className={styles.section}>
            <div className={styles.container}>
              <div className={styles.sectionPointsWrapper}>
                <div className={!selectAnalysisPoint ? styles.sectionPoint : styles.sectionPointActive}
                     onClick={() => {
                       if (!selectAnalysisPoint) {
                         dispatch(setSelectAnalysisPoint(true))
                         dispatch(setAnalysisPoints("&analysis=true"))
                         filters.setPageCount(1)
                       } else {
                         dispatch(setSelectAnalysisPoint(false))
                         dispatch(setAnalysisPoints(""))
                         filters.setPageCount(1)
                       }
                     }}
                >
                  {!selectAnalysisPoint ? (
                      <img
                          alt="img"
                          src={checkBoxEmpty}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectAnalysisPoint(true))
                            dispatch(setAnalysisPoints("&analysis=true"))
                            filters.setPageCount(1)
                          }}
                      />
                  ) : (
                      <img
                          alt="img"
                          src={checkBoxFull}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectAnalysisPoint(false))
                            dispatch(setAnalysisPoints(""))
                            filters.setPageCount(1)
                          }}
                      />
                  )}
                  Разборы компаний
                </div>

                <div className={!selectSubscription ? styles.sectionPoint : styles.sectionPointActive}
                     onClick={() => {
                       if (!selectSubscription) {
                         dispatch(setSelectSubscriptionPoint(true))
                         dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                         filters.setPageCount(1)
                       } else {
                         dispatch(setSelectSubscriptionPoint(false))
                         dispatch(setSubscriptionPoints(""))
                         filters.setPageCount(1)
                       }
                     }}
                >
                  {!selectSubscription ? (
                      <img
                          alt="img"
                          src={checkBoxEmpty}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectSubscriptionPoint(true))
                            dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                            filters.setPageCount(1)
                          }}
                      />
                  ) : (
                      <img
                          alt="img"
                          src={checkBoxFull}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectSubscriptionPoint(false))
                            dispatch(setSubscriptionPoints(""))
                            filters.setPageCount(1)
                          }}
                      />
                  )}
                  С подпиской Unity
                </div>

                <div
                    className={!selectBonds ? styles.sectionPoint : styles.sectionPointActive}
                    onClick={() => {
                      if (!selectBonds) {
                        dispatch(setSelectBondsPoint(true))
                        dispatch(setBondsPoints("&bonds=true"))
                        filters.setPageCount(1)
                      } else {
                        dispatch(setSelectBondsPoint(false))
                        dispatch(setBondsPoints(""))
                        filters.setPageCount(1)
                      }
                    }}
                >
                  {!selectBonds ? (
                      <img
                          alt="img"
                          src={checkBoxEmpty}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectBondsPoint(true))
                            dispatch(setBondsPoints("&bonds=true"))
                            filters.setPageCount(1)
                          }}
                      />
                  ) : (
                      <img
                          alt="img"
                          src={checkBoxFull}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectBondsPoint(false))
                            dispatch(setBondsPoints(""))
                            filters.setPageCount(1)
                          }}
                      />
                  )}
                  Облигации
                </div>

                <div
                    className={!selectPortfolios ? styles.sectionPoint : styles.sectionPointActive}
                    onClick={() => {
                      if (!selectPortfolios) {
                        dispatch(setSelectChangeInPortfolios(true))
                        dispatch(setChangePortfoliosPoints("&change_in_portfolios=true"))
                        filters.setPageCount(1)
                      } else {
                        dispatch(setSelectChangeInPortfolios(false))
                        dispatch(setChangePortfoliosPoints(""))
                        filters.setPageCount(1)
                      }
                    }}
                >
                  {!selectPortfolios ? (
                      <img
                          alt="img"
                          src={checkBoxEmpty}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectChangeInPortfolios(true))
                            dispatch(setChangePortfoliosPoints("&change_in_portfolios=true"))
                            filters.setPageCount(1)
                          }}
                      />
                  ) : (
                      <img
                          alt="img"
                          src={checkBoxFull}
                          className={styles.checkBoxEmpty}
                          onClick={() => {
                            dispatch(setSelectChangeInPortfolios(false))
                            dispatch(setChangePortfoliosPoints(""))
                            filters.setPageCount(1)
                          }}
                      />
                  )}
                  Изменение в портфелях
                </div>
              </div>
            </div>
          </section>
      )}
    </>
  )
}
export default SearchSectionFast
